import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';

import type { CustomerUserOrganisation } from 'api';
import { useGetCustomerOrganisations } from 'api';

import { Loading } from 'components/pages/Loading';
import { NoOrganisation } from 'components/pages/NoOrganisation';

export const RedirectToDefaultOrganisation = () => {
  const { data, isLoading } = useGetCustomerOrganisations();

  const defaultOrganisation = useMemo<CustomerUserOrganisation | undefined>(
    () =>
      data?.organisations.find((o) => o.default) || data?.organisations?.[0],
    [data]
  );

  if (isLoading) return <Loading />;

  if (defaultOrganisation)
    return <Navigate to={`/org/${defaultOrganisation.id}`} replace />;

  return <NoOrganisation />;
};
